import React from "react";
import "./Oops.css";

function Construction() {
  return (
    <div className="oopsie">
      <div>
        <h1>Mvelio.com</h1>
        <h2>
          Beta Testing...
        </h2>
      </div>
    </div>
  );
}

export default Construction;
